// eslint-disable-next-line import/prefer-default-export
export const DETAIL = {
  titleCommand: 'Détail de la commande',
  titleDevis: 'Détail du devis',
  titleFacture: 'Détail de la facture',
  titleFactureBailleur: 'Détail de la facture bailleur',
  titleTitreRecette: 'Détail du titre de recette',
  titleFactureAchatFournisseur: 'Détail de la facture d\'achat',
  titleAvoirAchatFournisseur: 'Détail de la facture d\'avoir d\'achat',
  titleAvoir: 'Détail de la facture d\'avoir',
  titleAvoirBailleur: 'Détail de la facture d\'avoir bailleur',
  titleAvoirTitreRecette: 'Détail avoir du titre de recette',
  titleAcompte: 'Détail de la facture d\'acompte',
  titleBonReception: 'Détail du bon de réception',
  codePostal: '{codePostal} - ',
  edition: {
    commande: 'Commande',
    devis: 'Devis',
    devisDetailLc: 'Devis avec détails LC',
    commandeDetailLc: 'Commande avec détails LC',
    devisSansLogo: 'Devis sans logo',
    commandeSansLogo: 'Commande sans logo',
    intervenantCopie: 'Facture avec intervenants en copie',
    factureSeule: 'Facture sans intervenants en copie',
    justificatifPose: 'Justificatif de pose théorique',
    factureSansLogo: 'Facture sans logo',
    factureDuplicata: 'Facture duplicata',
    factureLettreAnnulation1: 'Facture avec lettre impayée modèle 1',
    factureLettreAnnulation2: 'Facture avec lettre impayée modèle 2',
    dossierTempo: 'Dossier Tempo',
    dossierTempoAvecCumul: 'Dossier Tempo avec cumul',
    etiquette: 'Etiquette',
    grouperDansUnPdf: 'Grouper dans un fichier',
  },
  popUpSansSuite: {
    cancel: 'Annuler',
    sansSuite: 'Classer sans suite',
    mess: 'Etes-vous sûr de vouloir classer sans suite ce devis ?',
    messCommande: 'Etes-vous sûr de vouloir classer sans suite cette commande ?',
  },
  popUpCloture: {
    cancel: 'Annuler',
    close: 'Clôturer',
    mess: 'Etes-vous sûr de vouloir clôturer cette commande ?',
    closingDate: 'Date de clôture',
  },
  validation: {
    devisSansSuiteSuccess: 'Le devis a bien été classé sans suite',
    commandeSansSuiteSuccess: 'La commande a bien été classée sans suite',
    commandeClotureSuccess: 'La commande a bien été clôturée',
    demandeSignatureSucces: 'La demande de signature a été envoyée avec succès.',
    closeDemandeSignatureSucces: 'La demande de signature a été stoppée avec succès.',
  },
  remiseBancaireReglement: {
    title: 'Payer la facture',
    nomTire: 'Nom tiré',
    referenceTire: 'Référence du tiré',
    banque: 'Banque de destination',
    modeReglement: 'Mode de règlement',
    facturePayer: 'La facture a bien été payée.',
    warning: {
      domiciliationBancaire: 'Le règlement automatique d\'une facture n\'impacte pas la comptabilité, pour régler cette facture automatiquement vous devez avoir une domiciliation bancaire avec une interface comptable désactivée.',
    },
  },
  buttons: {
    aFacturer: 'Commande à facturer',
    factureAvoir: 'Facture/avoir',
    aRenouveler: 'Commandes à renouveler',
    edit: 'Modifier',
    create: 'Créer',
    editEcheancier: 'Modifier',
    delete: 'Supprimer',
    sansSuite: 'Sans suite',
    cloturer: 'Clôturer',
    archive: 'Archiver',
    cancel: 'Annuler',
    cancelFacture: 'Créer un avoir',
    save: 'Enregistrer',
    facturer: 'Facturer',
    commander: 'Commander',
    acompte: 'Saisir un acompte',
    payer: 'Payer',
    payerAutomatiquement: 'Règlement automatique',
    generateEcriture: 'MAJ Ecriture',
    exporterListeFacesVenduesReseauTempo: 'Exporter la liste des faces vendues',
    exporterLignesVentes: 'Exporter lignes de ventes',
    decloturerCommande: 'Réactiver la commande',
    stopSignature: 'Stopper l\'action de signature',
    indexation: 'Indexer',
    resetIndexation: 'Annuler la dernière indexation',
  },
  generalInfos: {
    title: 'Informations générales',
    dateDevis: 'Date de devis :',
    dateSignature: 'Date de signature :',
    estSigne: 'Signé',
    labelEstSigneSurCommande: 'Signée',
    dateValidite: 'Date de validité :',
    commercial: 'Commercial(e) :',
    assistante: 'Assistant(e) commercial(e) :',
    datePremierAffichage: 'Date de campagne :',
    dateEcheance: 'Date d\'échéance :',
    theme: 'Thème :',
    categorieVente: 'Type de produit : ',
    regleFacturation: 'Règle de facturation : ',
    agence: 'Agence : ',
    role: 'Rôle : ',
    commission: 'Commission :',
    commandeVenteInterne: 'Commande vente',
    commandeAchatInterne: 'Commande achat',
    campagne: 'Campagne : ',
  },
  acomptesAffectes: {
    factureAcompte: 'Facture {code}',
    dateMontant: 'du {date} de {montant}',
    title: 'Facture(s) d\'acomptes liée(s)',
  },
  client: {
    title: 'Intervenants',
    label: 'Client',
    address: 'Adresse commerciale :',
    contact: 'Contact(s) :',
  },
  intervenant: {
    annonceur: 'Annonceur',
    mandataire: 'Mandataire',
    donneurOrdre: 'Donneur d\'ordre',
  },
  devis: {
    title: 'Devis',
  },
  popup: {
    annulerFacture: 'Vous êtes sur le point d\'annuler une facture.',
    annulerFacturePayer: 'Cette facture a déjà reçue un règlement. Il sera nécessaire de vérifier votre encours clients après la création de l\'avoir.',
    annulerFactureAcompte: 'Vous êtes sur le point d\'annuler une facture d\'acompte.',
    avoirMessage: 'Un avoir total ou partiel sur la facture n°',
    avoirAcompteMessage: 'Un avoir sur la facture n°',
    finAvoirMessage: ' sera généré avec un montant négatif en date du :',
    annulerConfirm: 'Souhaitez-vous annuler la facture n°',
    annulerAcompteConfirm: 'Souhaitez-vous annuler l\'acompte n°',
    finAnnulerConfirm: ' ?',
    avoirPartiel: 'Créer un avoir partiel',
    avoirTotal: 'Créer un avoir total',
    avoirTotalRechargeFacture: 'Créer un avoir total et recharger ma facture',
    annuler: 'Annuler',
    creationAvoir: '1 Avoirs(s) créé(s)',
    commentaireAvoir: 'Commentaire pour l\'avoir',
    dateAvoir: 'Date de l\'avoir',
    commentaire: 'Commentaire',
  },
  descriptionLigneCommande: {
    semaine: 'S',
    du: 'du',
    au: 'au',
    nbFaces: 'Nb de faces:',
    surface: 'Surface',
    vente: '{value}% de vente',
    jours: 'jours',
    stand: 'Stand n°{num}',
    size: '{size} m²',
    parution: 'Parution {code} du {date}',
    dispositifSupport: 'Support: {support}',
    typeDispositif: 'Type de dispositif: {type}',
    format: 'Format: {format}',
    materielType: 'Type de  matériel: {materiel}',
    longueur: 'Longueur: {long}',
    largeur: 'Largeur: {lag}',
    isDoubleFace: 'Double face: {val}',
    eclaire: 'Eclairé: {val}',
  },
  commande: {
    title: 'Commande',
    commercial: {
      contact: 'Contact commercial :',
      email: 'Email :',
      tel: 'Tel :',
      reference: 'Référence client : ',
    },
    intervenant: {
      tvaIntracommunautaire: 'TVA intracommunautaire : {val}',
      destinataireComptableLabel: 'Destinataire comptable',
    },
    commandeAchatTitle: 'Commande n°',
    commission: 'Commi. :',
    historique: {
      title: 'Historique de commande',
      renouvellement: 'Renouvellement',
      tacite: 'Reconduction tacite',
      creation: 'Création de commande',
      renouvellementDescription: 'renouvelé à partir de la ',
      taciteDescription: 'issu d’une reconduction tacite de la',
      creationDescription: 'Création de la',
      commande: 'commande n°{code}',
      commandeMaj: 'Commande n°{code}',
      pasHistorique: 'Pas d\'historique pour la commande',
      boutonAfficherDetail: 'Afficher détail',
      boutonMasquerDetail: 'Masquer détail',
      achat: {
        title: 'Historique de bail',
        renouvellement: 'Renouvellement',
        reconduction: {
          title: 'Reconduction',
          for: 'le',
        },
        creation: 'Création de bail',
        renouvellementDescription: 'renouvelé à partir du ',
        creationDescription: 'Création du',
        commande: 'bail n°{code}',
        commandeMaj: 'Bail n°{code}',
        pasHistorique: 'Pas d\'historique pour le bail',
      },
    },
    folderCode: 'Code dossier : ',
    referenceDevis: 'Référence devis n°{number} du {date}',
    referenceCommande: 'Référence commande n°{number} du {date}',
    referenceCommandeAchat: 'Référence commande achat n°{number} du {date}',
    planMediaReference: 'Plan média n°{numero}',
    referenceContrat: 'Référence du contrat de bail n°{codeDossier}',
    referenceVersEcheancier: 'Référence dans l\'échéancier du bail n°{bail}',
    referenceVersRemiseBancaire: 'Référence de la remise bancaire',
    lignesCommande: {
      montantBrut: 'Montant Brut',
      montantNet: 'Montant Net',
      from: 'Du',
      to: 'au',
      description: 'Description',
      quantity: 'Quantité',
      unit: 'Unité',
      priceUnit: 'Prix Unit.',
      discount: 'Remise',
      tva: '% TVA',
      amount: 'Montant',
      quantiteDispo: '- Surface {quantiteDispo}%',
      montantFace: 'Montant face:',
      objectifAtteint: 'L\'objectif de {objectif} € est atteint',
      objectifNonAtteint: 'L\'objectif de {objectif} € n\'est pas atteint',
      ecranAssocies: '- Nb écrans associés : ',
      tooltip: {
        lienLocation: 'Lien vers le produit de location',
      },
    },
    repartitionsTva: {
      base: 'Base HT',
      rate: 'Taux',
      tva: 'TVA',
    },
    recapitulatifMontants: {
      totalHt: 'Total HT',
      tva: 'TVA',
      totalTtc: 'Total TTC',
      netAPayer: 'NET A PAYER',
      acompte: 'Acompte',
      horsTotal: 'Total hors {groupeProduitDeductible}',
    },
    repartitionMontants: {
      title: 'Votre part de paiement :',
    },
    selectionEcheances: {
      title: 'Facturer la commande n°',
      titleMulti: 'Facturer les commandes',
      repartitionLibelle: 'Répartition',
      cancel: 'Annuler',
      charge: 'Facturer',
      groupBills: 'Grouper les factures',
      billDate: 'Date de facture',
      billsDate: 'Date des factures',
      repartitionItem: {
        quantite: 'Quantité',
        prixUnitaire: 'Prix unitaire',
      },
      table: {
        payer: 'Payeur',
        product: 'Produit',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        amount: 'Montant échéance',
        billPrevDate: 'Date prév. de facturation',
      },
    },
    planMedia: 'Plan média :',
    regleFacturation: {
      label: 'Règle de facturation :',
      erreur: "La règle de facturation n'est pas cohérente avec les lignes de devis",
    },
    bonStockEntree: 'Bon de stock d\'entrée',
  },
  facture: {
    avoirFacture: 'Avoir sur facture n°',
    avoirAcompte: 'Avoir sur facture d\'acompte n°',
    facture: 'Facture n°',
    factureBailleur: 'Facture bailleur n°',
    titreRecette: 'Titre de recette n°',
    factureAchatFournisseur: 'Facture d\'achat n°',
    factureAvoir: 'Facture d\'avoir n°',
    factureAvoirBailleur: 'Avoir facture bailleur n°',
    titreRecetteAvoir: 'Avoir titre de recette n°',
    factureAcompte: 'Facture d\'acompte n°',
    factureAvoirAchatFournisseur: 'Avoir facture d\'achat n°',
  },
  schedule: {
    title: 'Échéancier de facturation',
    totalAmount: 'Montant total :',
    reglementPour: 'A facturer le : {date}',
    table: {
      product: 'Produit',
      amount: 'Montant HT de l\'échéancier',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      prevuePourLe: 'Prévue pour le',
      factureLe: 'Facturation',
      payment: 'Mode de règlement',
      aFacturer: 'A facturer',
      fournisseur: 'Fournisseur',
      valDiff: 'Valeurs différentes',
      commentaire: 'Commentaire',
    },
    indicateurFacturation: 'Facturée sans facture',
  },
  conditions: {
    penalite: 'En cas de retard de paiement, application d\'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008.',
    tauxPenalite: 'Taux de pénalité :',
    recouvrement: 'En cas de retard de paiement, application d\'une indemnité forfaitaire  pour frais de recouvrement de 40€ selon l\'article D. 441-5 du code du commerce.',
    tauxEscompte: 'Taux d\'escompte :',
    escompte: 'Pas d\'escompte appliquable.',
    commentaires: 'Commentaires',
    adresseLivraison: 'Adresse de livraison',
  },
  steps: {
    Brouillon: 'Brouillon',
    Commande: 'Commandé',
    Enregistre: 'Enregistré',
    Facture: 'Facturé',
    SansSuite: 'Sans suite',
    Paye: 'Payé',
    Clos: 'Clôturé',
    Annule: 'Annulé',
    FactureePartiellement: 'Facturé partiellement',
    Receptionnee: 'Réceptionnée',
    ReceptionneePartiellement: 'Réceptionnée partiellement',
    Cree: 'Créé',
    Rapproche: 'Rapproché',
    RapprochePartiellement: 'Rapproché partiellement',
  },
  periodicity: {
    Unite: 'Unité(s)',
    Annee: 'Année(s)',
    Mois: 'Mois',
    Semaine: 'Semaine(s)',
    Jour: 'Jour(s)',
    Pourcentage: 'Pourcentage',
    MetreCarre: 'Mètre(s) carré(s)',
    Face: 'Face(s)',
  },
  article: {
    date: 'Du {dateDebut} au {dateFin}',
    dateTempo: 'S{semaine} - du {dateDebut} au {dateFin}',
    semaine: 'S{semaine}',
    du: '- du',
    au: 'au',
    duMaj: 'Du',
    numberDays: '{nbJour} jour(s)',
    week: 'S{week}',
    indisponible: 'Produit non disponible',
    dejaAffecter: 'Face affectée à un réseau',
    dateDebut: 'Du {dateDebut}',
    parutionDu: 'Parution du {date}, {code}',
    needParution: 'Pas de parution sélectionné',
    parutionNotAvailable: 'La parution n\'est pas disponible',
    product: 'Produit',
    productAssocie: 'P. associé',
    libelle: 'Libellé',
    quantite: 'Quantité',
    priceUnit: 'Prix Unit.',
    montantBrut: 'Mnt brut',
    TauxTva: '% TVA',
    discount: 'Remise / Majo.',
    search: 'Recherche...',
    delete: 'Supprimer',
    associate: 'Associer un produit',
    calculerSurfaceDispo: 'Calculer la surface disponible',
    associateCommentaire: 'Associer un commentaire',
    noResult: 'Aucun résultat',
    facesSouhaitees: 'Faces souhaitées',
    facesSouhaiteesDisabled: 'Faces souhaitées non modifiable suite à l\'affectation logistique du réseau',
    dateReseau: '{ dateDebut } au { dateFin }',
    quantiteDispo: '% de surface',
    pourcentageVente: '% de vente',
    surface: 'Surface',
    numeroStand: 'N° stand',
    saturation: 'Saturation',
    saturationLabel: '1 /',
    selectFace: '{nbFace} faces sélectionnées',
    tarifUnitaire: 'Tarif unitaire',
    calculAutoTlpe: 'Calcul auto',
    prixUnitaireNet: 'PU net',
    objectif: 'Obj / face',
    montantFace: 'Mnt / face',
    produitArchive: 'Produit archivé',
    ecranAssocies: 'Nb écrans',
    ligneCommandeDispositif: {
      nomDispositif: 'Nom du dispositif',
      dispositifSupport: 'Support',
      typeDispositif: 'Type de dispositif',
      format: 'Format',
      materielType: 'Type de  matériel',
      longueur: 'Longueur',
      largeur: 'Hauteur',
      isDoubleFace: 'Double face',
      eclaire: 'Eclairé',
    },
  },
  popUpChangeDateLocation: {
    title: 'Modification des dates d\'affichages',
    terminer: 'Terminer',
    cancel: 'Annuler',
    week: 'S{semaine}',
  },
  compteComptable: 'Compte comptable',
  ongletFacture: {
    facture: 'Facture',
    ecritureCompta: 'Ecriture comptable',
    previsualisation: 'Paramétrage édition',
    achats: 'Achats',
    commissionFournisseur: 'Commissions fournisseur',
    factor: 'Factor',
    relance: 'Relance',
  },
  infos: {
    devis: 'La société du devis est différente de la société active',
    commande: 'La société de la commande est différente de la société active',
    facture: 'La société de la facture est différente de la société active',
  },
  popUpFaceSelectInReseauTempoOfReseauPerso: {
    title: 'Faces sélectionnées',
    reseau: 'Réseaux Temporaires',
    nbFacesSelect: '{total} faces sélectionnées',
    tab: {
      dispo: 'Dispo',
      panneau: 'Panneau',
      codeReseau: 'Code Réseau',
      reseauLibelle: 'Libellé réseau',
      dateDepart: 'Date départ réseau',
      face: 'Face',
      format: 'Format',
      adresse: 'Adresse',
      ville: 'Ville',
      restriction: 'Restriction',
      logistique: 'Logistique',
      codePostal: 'CP',
      materielType: 'Matériel',
    },
    anneeSemaine: 'S{week} - {year}',
    dispo: 'Disponible',
    nonDispo: 'Non disponible',
    affecte: 'Affecté',
    nonAffecte: 'Non affecté',
    indispo: {
      inactif: 'La face est inactive',
      dejaPris: 'La face est déjà affectée sur le visuel "{visuel}"',
      libre: 'La face n\'a pas été affectée mais elle est disponible',
      sansPatrimoine: 'Ce produit n\'a pas de face associée dans le patrimoine',
    },
  },
  dcfSignable: {
    etatEnregisteRequis: 'Le devis n\'est pas à l\'état "enregistré".',
    donneurdOrdeRequis: 'Il doit y avoir un et un seul donneur d\'ordre.',
    erreurEmail: 'Le contact sélectionné doit avoir une adresse e-mail valide.',
    erreurPortable: 'Le contact sélectionné doit avoir un numéro de téléphone portable valide.',
    erreurSignatureHisto: 'Il y a une procédure de signature en cours pour ce devis.',
    erreurEtatObtenuLigne: 'L\'une des lignes suivantes doit avoir un état obtenu "bloqué": {libelles}',
    erreurContactDonneurDordreRequis: 'Le donneur d\'ordre doit avoir un contact sélectionné.',
    erreurNomContact: 'Le nom du contact sélectionné est obligatoire.',
    erreurPrenomContact: 'Le prénom du contact sélectionné est obligatoire.',
    etatDifferentSansSuiteOuClos: 'La commande doit avoir un état différent de "sans suite" ou "clos"',
    erreurSignatureHistoCommande: 'Il y a une procédure de signature en cours pour cette commande.',
    dejaSigne: 'La signature est déjà effectuée.',
    signatureImpossible: 'Signature impossible, veuillez paramétrer votre société',
  },
  signatureElectronique: {
    messageDemandeValidee: 'Signature effectuée',
    messageDemandeAnnulee: 'Demande signature annulée',
    messageDemandeEnvoyee: 'Demande signature en cours',
    dateEnvoie: 'Date d\'envoi: ',
    dateSignature: 'Date de signature: ',
    demandeur: 'Demandeur: ',
    titleDevis: 'Signature devis',
    titleCommande: 'Signature commande',
    nbreSignatureCommande: 'Signature(s) en cours',
    nbreSignatureDevis: 'Signature(s) en cours',
  },
  popUpEnvoieDemandeSignature: {
    title: 'Envoyer une demande de signature électronique',
    donneurdOrde: 'Donneur d\'ordre :',
    adresse: 'Adresse',
    telephonePortable: 'Téléphone portable ',
    email: 'Email ',
    tabs: {
      nom: 'Nom',
      prenom: 'Prénom',
      service: 'Service',
      fonction: 'Fonction',
      telephone: 'Téléphone',
      portable: 'Portable',
      email: 'Email',
    },
    messages: {
      demandeSignatureSucces: 'La demande de signature a été envoyée avec succès.',
      closeDemandeSignatureSucces: 'La demande de signature a été stoppée avec succès.',
    },
    stopperActionSignature: 'Stopper signature',
    ajouterPj: 'Ajouter une pièce jointe',
    pdfOnly: 'pdf uniquement',
    contacts: 'Contacts',
    transaction: 'Transactions précédentes',
  },
  bonReception: {
    detailTitle: 'Bon de réception n°',
  },
};
